import React, { memo } from "react";
import { Box, FormControlLabel, Grid } from "@mui/material";
import { Form, FormikProps, useFormikContext } from "formik";
import pageStyles from "../../pageStyles";
import SectionWrapper from "./../../../common/pageSections/SectionWrapper";
import ProcessorBin from "./ProcessorBin";
import ProcessorCardType from "./ProcessorCardType";
import FormSubmitButtons from "../../../common/buttons/FormSubmitButtons";
import TextInput from "../../../common/formElements/TextInput";
import { useToastMessage } from "../../../effects/useToastMessage";
import CustomizedSwitch from "../../../common/formElements/Switch";
import { Data } from "../../../store/processor/types";

const ProcessorEditForm = () => {
  const classes = pageStyles();
  const formProps = useFormikContext<FormikProps<Data>>();
  const { setFieldValue, errors, isSubmitting } = formProps;
  const values = formProps.values as unknown as Data;

  // Show toast errors
  useToastMessage(isSubmitting, errors);

  return (
    <Form className={classes.formWrapper as string}>
      <SectionWrapper title="Processor">
        <SectionWrapper title="Processor Info" isChild>
          <Grid container spacing={2}>
            <Grid item xs={12} md={3}>
              <TextInput fieldname="attributes.Name" label="Processor Name*" />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextInput fieldname="attributes.FIIC" label="FIIC" />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextInput fieldname="attributes.Host" label="Host*" />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextInput fieldname="attributes.Port" label="Port*" />
            </Grid>
          </Grid>
        </SectionWrapper>
        <SectionWrapper title="Configuration" isChild>
          <Box p={2} pt={0}>
            <FormControlLabel
              style={{ marginRight: "3rem" }}
              control={
                <CustomizedSwitch
                  checked={
                    values.attributes.MaintainTransactionSequence as boolean
                  }
                  onChange={(event) => {
                    setFieldValue(
                      "attributes.MaintainTransactionSequence",
                      event.target.checked
                    );
                  }}
                />
              }
              label="Maintain Transaction Sequence"
            />
          </Box>
        </SectionWrapper>
        <ProcessorCardType />
        <ProcessorBin />
      </SectionWrapper>
      <FormSubmitButtons />
    </Form>
  );
};
export default memo(ProcessorEditForm);
